import { Button } from "@faire/web/slate-deprecated/Button";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import ClickOutside from "@faire/web/ui/ClickOutside";
import React, { useCallback } from "react";
import styled from "styled-components";

export const HeaderClickItem: React.FC<{
  children: React.ReactNode;
  clickChild: React.ReactNode;
  dataTestId?: string;
  ariaLabel?: string;
  shouldShowDropdown: boolean;
  toggleDropdown: (
    shouldShowDropdown: boolean,
    isOutsideClick: boolean
  ) => void;
  shouldDisableClick?: boolean;
  onClick?: () => void;
  className?: string;
}> = ({
  clickChild,
  children,
  dataTestId,
  ariaLabel,
  toggleDropdown,
  shouldShowDropdown,
  shouldDisableClick,
  onClick,
  className,
}) => {
  const handleOnClick = () => {
    if (!shouldDisableClick) {
      toggleDropdown(!shouldShowDropdown, false);
    }
    onClick?.();
  };

  const handleOnClickOutside = useCallback(() => {
    toggleDropdown(false, true);
  }, [toggleDropdown]);

  return (
    <ClickOutside onClickOutside={handleOnClickOutside} className={className}>
      <ClickItem
        onClick={handleOnClick}
        aria-label={ariaLabel}
        data-test-id={dataTestId}
        variant="tertiary"
      >
        {children}
      </ClickItem>
      {shouldShowDropdown ? clickChild : null}
    </ClickOutside>
  );
};

export const ClickItem = styled(Button)`
  &:hover {
    cursor: pointer;
  }
  ${responsiveMediaQueries.mobile} {
    margin-top: 12px;
  }
`;
